import React, { Component } from 'react';

import { Elements } from 'react-stripe-elements';

import { Container } from 'semantic-ui-react';

import CardForm from './card-form';

export default class PaymentForm extends Component {
  render() {
    return (
      <Container>
        <Elements>
          <CardForm />
        </Elements>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/container/payment-form/index.js